import { useTranslation } from 'react-i18next';
import styles from './RedCards.module.css';

/**
 * A team's cards beside its name in live play: a red card and a yellow card,
 * each with how many the team has written on it (red first). A colour the
 * team has none of is left out; nothing at all when it has neither.
 */
export const RedCards = ({
  count,
  yellow,
}: {
  /** Red cards. */
  count?: number;
  yellow?: number;
}) => {
  const { t } = useTranslation();
  const red = count && count > 0 ? count : 0;
  const yel = yellow && yellow > 0 ? yellow : 0;
  if (!red && !yel) return null;
  const label = [
    red ? t('live_red_cards', { count: red }) : '',
    yel ? t('live_yellow_cards', { count: yel }) : '',
  ]
    .filter(Boolean)
    .join(', ');
  return (
    <span className={styles.cards} title={label} aria-label={label} role="img">
      {red > 0 && <i className={styles.red}>{red}</i>}
      {yel > 0 && <i className={styles.yellow}>{yel}</i>}
    </span>
  );
};
